import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./useContext";

const useRoleAuth = (requiredRoles: string[]): boolean => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const LOGGED_IN = user !== null ? true : false;
  if (LOGGED_IN) {}
  const TOKEN = localStorage.getItem("token") as string;
  const USER: any = jwt_decode(TOKEN);

  if (!requiredRoles) {
    return false;
  }

  const roleValide = requiredRoles.some((role) =>
    USER["cognito:groups"].find((rol: string) => rol === role)
  );

  if (roleValide === false) navigate("/acceso-restringido", { replace: true });
  return roleValide;
};

export { useRoleAuth };
